import { useEffect, useState } from "react";

import {
    Link,
    useParams,
} from "react-router-dom";

import {
    FiArrowLeft,
    FiCheckCircle,
    FiFileText,
    FiUser,
    FiXCircle,
} from "react-icons/fi";

import {
    getCollection,
} from "services/api/collectionApi";

import {
    showError,
} from "utils/toast";


export default function CollectionDetail() {

    const { id } =
        useParams();


    const [
        collection,
        setCollection,
    ] = useState(null);


    const [
        loading,
        setLoading,
    ] = useState(true);


    useEffect(() => {

        const load =
            async () => {

                try {

                    const response =
                        await getCollection(
                            id
                        );

                    setCollection(
                        response?.data?.collection ||
                        null
                    );

                }
                catch (error) {

                    showError(
                        error?.response?.data?.message ||
                        "Unable to load collection."
                    );

                }
                finally {

                    setLoading(
                        false
                    );

                }

            };


        load();

    }, [id]);


    if (loading) {

        return (
            <div className="mt-5 p-10 text-center">
                Loading...
            </div>
        );

    }


    if (!collection) {

        return (
            <div className="mt-5 p-10 text-center">
                Collection not found.
            </div>
        );

    }


    const statusClass =
        collection.status === "verified"
            ? "bg-green-100 text-green-700"
            : collection.status === "submitted"
            ? "bg-blue-100 text-blue-700"
            : collection.status === "rejected"
            ? "bg-red-100 text-red-700"
            : collection.status === "cancelled"
            ? "bg-gray-200 text-gray-600"
            : "bg-gray-100 text-gray-700";


    return (

        <div className="mt-5 space-y-5">


            <div
                className="
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                "
            >

                <div
                    className="
                        flex
                        items-center
                        justify-between
                        gap-4
                    "
                >

                    <div>

                        <Link
                            to="/admin/collections"
                            className="
                                mb-3
                                inline-flex
                                items-center
                                gap-2
                                text-sm
                                text-gray-500
                            "
                        >
                            <FiArrowLeft />
                            Back to Collections
                        </Link>


                        <h1
                            className="
                                text-2xl
                                font-bold
                                text-navy-700
                            "
                        >
                            Collection #{collection.id}
                        </h1>

                    </div>


                    <span
                        className={`
                            rounded-full
                            px-4
                            py-2
                            text-sm
                            font-semibold
                            capitalize
                            ${statusClass}
                        `}
                    >
                        {
                            collection.status
                        }
                    </span>

                </div>

            </div>


            <div
                className="
                    grid
                    grid-cols-1
                    gap-5
                    md:grid-cols-2
                    xl:grid-cols-4
                "
            >

                <InfoCard
                    title="Amount"
                    value={`₹${collection.amount}`}
                />


                <InfoCard
                    title="Payment Mode"
                    value={
                        collection.mode?.replace(
                            /_/g,
                            " "
                        )
                    }
                />


                <InfoCard
                    title="Customer"
                    value={
                        collection.party?.name ||
                        collection.school?.name ||
                        "-"
                    }
                />


                <InfoCard
                    title="Employee"
                    value={
                        collection.employee?.name ||
                        "-"
                    }
                />

            </div>


            <div
                className="
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                "
            >

                <h2
                    className="
                        mb-5
                        text-lg
                        font-bold
                        text-navy-700
                    "
                >
                    Collection Information
                </h2>


                <div
                    className="
                        grid
                        grid-cols-1
                        gap-5
                        md:grid-cols-2
                        lg:grid-cols-3
                    "
                >

                    <Info
                        label="Collection Date"
                        value={
                            collection.collectionDate
                                ? new Date(
                                    collection.collectionDate
                                ).toLocaleDateString()
                                : "-"
                        }
                    />


                    <Info
                        label="Balance Type"
                        value={
                            collection.balanceType
                        }
                    />


                    <Info
                        label="Reference No."
                        value={
                            collection.referenceNo
                        }
                    />


                    <Info
                        label="Cheque No."
                        value={
                            collection.chequeNo
                        }
                    />


                    <Info
                        label="Bank Name"
                        value={
                            collection.bankName
                        }
                    />


                    <Info
                        label="Verified By"
                        value={
                            collection.verifiedBy?.name
                        }
                    />

                </div>


                {
                    collection.remarks && (

                        <div className="mt-5">

                            <Info
                                label="Remarks"
                                value={
                                    collection.remarks
                                }
                            />

                        </div>

                    )
                }


                {
                    collection.rejectionReason && (

                        <div
                            className="
                                mt-5
                                rounded-lg
                                bg-red-50
                                p-4
                                text-red-700
                            "
                        >
                            <div className="flex gap-2 font-semibold">

                                <FiXCircle />

                                Rejection Reason

                            </div>

                            <div className="mt-2 text-sm">
                                {
                                    collection.rejectionReason
                                }
                            </div>

                        </div>

                    )
                }

            </div>


            <div
                className="
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                "
            >

                <h2
                    className="
                        mb-4
                        text-lg
                        font-bold
                        text-navy-700
                    "
                >
                    Linked Visit
                </h2>


                {
                    collection.visit ? (

                        <div
                            className="
                                rounded-lg
                                bg-gray-50
                                p-4
                            "
                        >

                            <div
                                className="
                                    font-semibold
                                "
                            >
                                Visit #{collection.visit.id}
                            </div>

                            <div
                                className="
                                    mt-1
                                    text-sm
                                    text-gray-600
                                "
                            >
                                {
                                    collection.visit.purpose ||
                                    "Visit"
                                }
                            </div>

                        </div>

                    ) : (

                        <div className="text-sm text-gray-500">
                            No visit linked.
                        </div>

                    )
                }

            </div>


            <div
                className="
                    rounded-2xl
                    bg-white
                    p-5
                    shadow-sm
                "
            >

                <h2
                    className="
                        mb-4
                        text-lg
                        font-bold
                        text-navy-700
                    "
                >
                    Receipts
                </h2>


                {
                    collection.receipts?.length ? (

                        <div className="space-y-3">

                            {
                                collection.receipts.map(
                                    (receipt) => (

                                        <div
                                            key={
                                                receipt.id
                                            }
                                            className="
                                                flex
                                                items-center
                                                gap-3
                                                rounded-lg
                                                border
                                                p-3
                                            "
                                        >

                                            <FiFileText />


                                            <div
                                                className="
                                                    min-w-0
                                                    flex-1
                                                "
                                            >
                                                <div
                                                    className="
                                                        break-all
                                                        text-sm
                                                    "
                                                >
                                                    {
                                                        receipt.filePath
                                                    }
                                                </div>

                                                {
                                                    receipt.caption && (
                                                        <div
                                                            className="
                                                                text-xs
                                                                text-gray-500
                                                            "
                                                        >
                                                            {
                                                                receipt.caption
                                                            }
                                                        </div>
                                                    )
                                                }

                                            </div>


                                            <a
                                                href={
                                                    `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/uploads/${receipt.filePath}`
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                                className="
                                                    rounded-lg
                                                    bg-blue-600
                                                    px-3
                                                    py-2
                                                    text-xs
                                                    font-semibold
                                                    text-white
                                                "
                                            >
                                                View
                                            </a>

                                        </div>

                                    )
                                )
                            }

                        </div>

                    ) : (

                        <div className="text-sm text-gray-500">
                            No receipts attached.
                        </div>

                    )
                }

            </div>


        </div>

    );

}


function InfoCard({
    title,
    value,
}) {

    return (

        <div
            className="
                rounded-2xl
                bg-white
                p-5
                shadow-sm
            "
        >

            <div className="text-sm text-gray-500">
                {title}
            </div>

            <div
                className="
                    mt-2
                    text-xl
                    font-bold
                    capitalize
                    text-navy-700
                "
            >
                {value || "-"}
            </div>

        </div>

    );

}


function Info({
    label,
    value,
}) {

    return (

        <div>

            <div
                className="
                    text-xs
                    font-semibold
                    uppercase
                    text-gray-500
                "
            >
                {label}
            </div>

            <div
                className="
                    mt-1
                    text-sm
                    font-semibold
                    text-gray-800
                "
            >
                {value || "-"}
            </div>

        </div>

    );

}